import { DeviceAlertData, DeviceData } from "@/app/interfaces";

export function getUsernameFromEmail(email: string | undefined): string {
  if (!email) return "";
  return email.split("@")[0];
}

export function formatTime(timestamp: number) {
  return new Date(timestamp).toLocaleString("en-GB", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

export function decodeValueToCodes(value: number): string[] {
  const codes: string[] = [];
  for (let bit = 0; bit < 16; bit++) {
    if ((value >> bit) & 1) {
      const byteIndex = Math.floor(bit / 8); // 0 for bits 0–7, 1 for bits 8–15
      const bitInByte = bit % 8; // position within that byte (0…7)
      codes.push(`${byteIndex}.${bitInByte}`);
    }
  }
  return codes;
}

// /**
//  * Given all device data, a list of register names (errorNames or maintenanceNames),
//  * and a code→text map, returns a flat array of {text,timestamp} sorted newest first.
//  */
// export function getAlerts(
//   data: DeviceData[],
//   names: string[],
//   codeMap: Record<string, Record<string, string>>
// ): { text: string; timestamp: number }[] {
//   const out: { text: string; timestamp: number }[] = [];

//   for (const name of names) {
//     const pts = data.filter((d) => d.name === name);
//     if (!pts.length) continue;

//     const latest = pts.reduce((a, b) => (a.timestamp > b.timestamp ? a : b));
//     if (latest.value === 0) continue;

//     const codes = decodeValueToCodes(latest.value);
//     for (const code of codes) {
//       const text =
//         codeMap[name]?.[code] ?? `${name} ${code} – kirjeldus puudub`;
//       out.push({ text, timestamp: latest.timestamp });
//     }
//   }

//   return out.sort((a, b) => b.timestamp - a.timestamp);
// }

// export function getAllAlerts(
//   data: DeviceData[],
//   names: string[],
//   codeMap: Record<string, Record<string, string>>
// ): DeviceAlertData[] {
//   const out: { text: string; timestamp: number }[] = [];

//   for (const { name, value, timestamp } of data) {
//     if (value === 0 || !names.includes(name)) continue;

//     const codes = decodeValueToCodes(value);
//     for (const code of codes) {
//       out.push({
//         text: codeMap[name]?.[code] ?? `${name} ${code} – kirjeldus puudub`,
//         timestamp,
//       });
//     }
//   }

//   return out.sort((a, b) => b.timestamp - a.timestamp);
// }
